module.exports = __webpack_public_path__ + "7715fb747e651e9313bb8c75556ff2c3.png";